import { CHANGE_CAREER_MEMBERSHIP, CHANGE_CAREER_STATUS, DELETE_CAREER_USER, SET_CAREER_USER, ADD_CAREER_USER, EDIT_CAREER_USER, CAREER_COURSE_UNENROLL } from "../constant";

const initialState = [];

export const careerLaunchUserReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_CAREER_USER: {
            state = [...payload];
            return state;
        }
        case ADD_CAREER_USER: {
            let temp = [...state];
            let index = temp.findIndex(user => user.email === payload.email);
            if (index > -1) {
                temp[index] = payload;
            } else {
                temp = [payload, ...temp]
            }
            return temp;
        }
        case EDIT_CAREER_USER: {
            let temp = [...state];
            let index = temp.findIndex(user => user._id === payload._id);
            if (index > -1) {
                temp[index] = payload;
            }
            return temp;
        }
        case CHANGE_CAREER_STATUS: {
            let temp = [...state];
            let index = temp.findIndex(user => user._id === payload);
            if (index > -1) {
                temp[index].is_active = !temp[index].is_active;
            }
            return temp;
        }
        case CHANGE_CAREER_MEMBERSHIP: {
            let temp = [...state];
            let index = temp.findIndex(user => user._id === payload._id);
            if (index > -1) {
                temp[index] = payload;
            }
            return temp;
        }
        case CAREER_COURSE_UNENROLL: {
            let temp = [...state];
            let index = temp.findIndex(user => user._id === payload.user_id);
            if (index > -1) {
                temp[index].enroll_course = temp[index].enroll_course.filter(_ => _.course_id !== payload.course_id);
                temp[index].enroll_count = temp[index].enroll_count - 1;
            }
            return temp;
        }
        case DELETE_CAREER_USER: {
            let temp = [...state];
            let index = temp.findIndex(user => user._id === payload);
            if (index > -1) {
                temp.splice(index, 1);
            }
            return temp;
        }
        default: {
            return state
        }
    }
};